export default {
  apiUrl: process.env.REACT_APP_API_URL,
  ziggeoKey: process.env.REACT_APP_ZIGGEO,
  s3Url: process.env.REACT_APP_S3_URL,
  backendUrl: process.env.REACT_APP_URL_BACKEND,
  lambdaUrl: process.env.REACT_APP_LAMBDA_URL,
}
